import { request } from '~/api/_utils/request';

const getPath = ({ competitionId, presentationId }: Params) =>
  `/v1/competitions/${competitionId}/presentations/${presentationId}/vote`;

type Params = {
  competitionId: string | number;
  presentationId: string | number;
};

export async function apiPostV1CompetitionByIdPresentationByIdVote(it: Params) {
  const response = await request.POST<{}>(getPath(it));
  return response;
}
